import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { cancellationRefundPolicyList } from './constants';

const CancellationRefundPolicy = () => {

   useEffect(() => {
      const element = document.getElementById('landingPage')
      element.scrollIntoView({
         block: "start",
         inline: "nearest"
      });
   }, [])

   return (
      <>
         <div id="landingPage" className='faq-header'>
            <Navbar />
         </div >
         <main className='container details-section'>
            <div className='details-wrap pb-5'>
               <h2>
                  Cancellation and Refund Policy
               </h2>
               <p>
                  Any Capitalized terms used but not defined herein shall have the meaning assigned to them
                  under the Terms of Use which govern your use of our website www.enjoyfresh.com (the
                  “Website”) and our ‘enjoyfresh’ application for mobile and handheld devices (the “App”). The
                  Website and the App are jointly referred to as the “Platform”.
               </p>
               {
                  cancellationRefundPolicyList.map((cancellationRefundPolicy) => {
                     return <div key={cancellationRefundPolicy.no}>
                        <h6>{cancellationRefundPolicy.question}</h6>
                        {
                           cancellationRefundPolicy.answer && cancellationRefundPolicy.answer.length > 0 ? (
                              cancellationRefundPolicy.answer.map((cancellationRefundPolicyItem, cancellationRefundPolicyItemIndex) => {
                                 return <p key={cancellationRefundPolicyItemIndex}>{cancellationRefundPolicyItem}</p>
                              })
                           ) : ""
                        }
                     </div>
                  })
               }
            </div>
         </main>
         <Footer />
      </>
   )
};

export default CancellationRefundPolicy;
